"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _ListByline = _interopRequireDefault(require("./_ListByline"));

var _ListFooter = _interopRequireDefault(require("./_ListFooter"));

var _ListHeader = _interopRequireDefault(require("./_ListHeader"));

var _ListIcon = _interopRequireDefault(require("./_ListIcon"));

var _ListItem = _interopRequireDefault(require("./_ListItem"));

var _ListSelection = _interopRequireDefault(require("./_ListSelection"));

var _ListText = _interopRequireDefault(require("./_ListText"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _list.default);
/** **List** and **Table** are similar as both usually contain a vertical list of data,
but lists generally contain basic data and tables tend to hold more complex data.
If the list is a complex hierarchy, it is best to use a **Tree**. */

var List = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames, _context;

  var children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      compact = _ref.compact,
      footer = _ref.footer,
      footerClassName = _ref.footerClassName,
      hasByline = _ref.hasByline,
      header = _ref.header,
      headerClassName = _ref.headerClassName,
      headerStyle = _ref.headerStyle,
      id = _ref.id,
      level = _ref.level,
      navigation = _ref.navigation,
      noBorder = _ref.noBorder,
      partialNavigation = _ref.partialNavigation,
      selectable = _ref.selectable,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "cssNamespace", "compact", "footer", "footerClassName", "hasByline", "header", "headerClassName", "headerStyle", "id", "level", "navigation", "noBorder", "partialNavigation", "selectable"]);
  var listClasses = classnames("".concat(cssNamespace, "-list"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list--selection"), selectable), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list--compact"), compact), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list--no-border"), noBorder), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list--byline"), hasByline), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list--navigation"), navigation || partialNavigation), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list--navigation-indication"), navigation || partialNavigation), _classnames), className);
  var listId = (0, _useUniqueId.default)(id);
  var listHeaderId = "".concat(listId, "-header");
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header && /*#__PURE__*/_react.default.createElement(List.Header, {
    className: headerClassName,
    headingStyle: headerStyle,
    id: listHeaderId,
    level: level
  }, header), /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, props, {
    "aria-labelledby": header ? listHeaderId : null,
    className: listClasses,
    id: "".concat(listId, "-list"),
    ref: ref,
    role: selectable ? 'listbox' : 'list'
  }), (0, _map.default)(_context = _react.default.Children).call(_context, children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      hasByline: hasByline,
      navigation: navigation,
      partialNavigation: partialNavigation
    });
  })), footer && /*#__PURE__*/_react.default.createElement(List.Footer, {
    className: footerClassName
  }, footer));
});

List.displayName = 'List';
process.env.NODE_ENV !== "production" ? List.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** The list footer as a String or a React node.*/
  footer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /** CSS class(es) to add to the list footer */
  footerClassName: _propTypes.default.string,

  /** Set to **true** if any list item has a byline. */
  hasByline: _propTypes.default.bool,

  /** The list header as a String or a React node.*/
  header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /** CSS class(es) to add to the list header */
  headerClassName: _propTypes.default.string,

  /** Heading style, if it should be different from the default style for the heading level. */
  headerStyle: _CustomPropTypes.default.range(2, 6),

  /** Unique id for the list, used to associate `List.Header` as the list label for accessibility. A generated value will be used if not set.*/
  id: _propTypes.default.string,

  /** List header's semantic level. `<h1>` is reserved for the page title. It should not appear in components */
  level: _CustomPropTypes.default.range(2, 6),

  /** Set to **true** if all list items are links */
  navigation: _propTypes.default.bool,

  /** Set to **true** to remove borders from the List component. */
  noBorder: _propTypes.default.bool,

  /** Set to **true** if any list item is a link, but not all */
  partialNavigation: _propTypes.default.bool,

  /** Set to **true** if list is an option list i.e. `List.Item` contain `List.Selection`. Do not add non-selectable list items to such lists for accessibility reasons.*/
  selectable: _propTypes.default.bool
} : void 0;
List.defaultProps = {
  level: 4
};
List.Footer = _ListFooter.default;
List.Header = _ListHeader.default;
List.Item = _ListItem.default;
List.Icon = _ListIcon.default;
List.Text = _ListText.default;
List.Byline = _ListByline.default;
List.Selection = _ListSelection.default;

var _default = (0, _withStyles.default)(List);

exports.default = _default;